import { render, staticRenderFns } from "./McrFormB.vue?vue&type=template&id=5455a437"
import script from "./McrFormB.vue?vue&type=script&lang=js"
export * from "./McrFormB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports